<template>
  <div class="border-neutral-95 flex h-14 w-full justify-between self-center border-b bg-white shadow-sm">
    <slot />
  </div>
</template>
